import moment from 'moment-timezone'

import { COUNTRY_CODES } from '../constants'

export const isSupportedCountry = (countryCode) => COUNTRY_CODES.includes(countryCode)

export const sortHolidays = (holidays) => holidays
  .slice()
  .sort((a, b) => moment(a.dateObserved).dayOfYear() - moment(b.dateObserved).dayOfYear())
